import gql from 'graphql-tag';

import { courseFragment } from '~/shared/graphql-queries/courses/index';

export default gql`
  query findByIdCourseQuery($_id: MongoID!) {
    findByIdCourseQuery(_id: $_id) {
      ...CourseFragment
    }
  }
  ${courseFragment}
`;
